var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKinematicTests(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 38,
    viewBox: "0 0 47 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3409_3526)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.6035 7.96525C37.0829 7.96525 38.2932 6.7549 38.2932 5.27559C38.2932 3.79628 37.0829 2.58594 35.6035 2.58594C34.1242 2.58594 32.9139 3.79628 32.9139 5.27559C32.9139 6.7549 34.1242 7.96525 35.6035 7.96525ZM30.6277 12.5377L26.8622 31.4997H29.6863L32.107 20.7411L34.9311 23.4308V31.4997H37.6208V21.4135L34.7966 18.7239L35.6035 14.6894C37.3518 16.7066 40.0415 18.0515 43.0001 18.0515V15.3618C40.4449 15.3618 38.2932 14.017 37.2173 12.1342L35.8725 9.98249C35.3346 9.17559 34.5277 8.63766 33.5863 8.63766C33.1829 8.63766 32.9139 8.77214 32.5104 8.77214L25.5173 11.7308V18.0515H28.207V13.479L30.6277 12.5377Z",
    fill: "#255986"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21.4827,
    y1: 13.8447,
    x2: 8.03439,
    y2: 13.8447,
    stroke: "#64C1B4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24.1724,
    y1: 27.293,
    x2: 10.7241,
    y2: 27.293,
    stroke: "#64C1B4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21.4827,
    y1: 20.5688,
    x2: 3.99991,
    y2: 20.5688,
    stroke: "#255986"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.2759,
    cy: 22.086,
    r: 0.672414,
    fill: "#64C1B4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.8621,
    cy: 12.6719,
    r: 0.672414,
    fill: "#64C1B4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.4178,
    cy: 26.1207,
    r: 0.672414,
    fill: "#64C1B4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.293,
    cy: 15.3619,
    r: 0.672414,
    fill: "#64C1B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3409_3526",
    x: 0,
    y: 0.585938,
    width: 47,
    height: 36.9136,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.145098 0 0 0 0 0.34902 0 0 0 0 0.52549 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3409_3526"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3409_3526",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKinematicTests);
export default __webpack_public_path__ + "static/media/kinematic-tests.75a1f8033607273eeaac731161fbbe39.svg";
export { ForwardRef as ReactComponent };